export default __webpack_public_path__ + "static/media/bas-rose.a35dee14.svg";